import { render } from "./OpponentGoal.vue?vue&type=template&id=33bb61fb"
import script from "./OpponentGoal.vue?vue&type=script&lang=js"
export * from "./OpponentGoal.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__